import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home/index.vue';
import SupplierRegister from '../views/supplier/Register.vue';
import ExpertRegister from '../views/expert/Register.vue';
import ProcurementInfo from '../views/procurement/index.vue';
import ProcurementDetail from '../views/procurement/Detail.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue'),
    meta: { title: '登录' },
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '首页' },
  },
  {
    path: '/supplier-register',
    name: 'SupplierRegister',
    component: SupplierRegister,
    meta: { title: '供应商注册' },
  },
  {
    path: '/expert-register',
    name: 'ExpertRegister',
    component: ExpertRegister,
    meta: { title: '专家注册' },
  },
  {
    path: '/procurement-info',
    name: 'ProcurementInfo',
    component: ProcurementInfo,
    meta: { title: '招标信息' },
  },
  {
    path: '/procurement-detail',
    name: 'ProcurementDetail',
    component: ProcurementDetail,
    meta: { title: '招标信息详情' },
  },
  {
    path: '/policy-regulations',
    name: 'PolicyRegulations',
    component: () => import('../views/policy/index.vue'),
    meta: { title: '政策法规' },
  },
  {
    path: '/policy-regulations/:id',
    name: 'PolicyRegulationsDetail',
    component: () => import('../views/policy/Detail.vue'),
    meta: { title: '政策法规详情' },
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/others/Services.vue'),
    meta: { title: '增值服务' },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/others/Contact.vue'),
    meta: { title: '联系我们' },
  },
 
  {
    path: '/supplier-center/project-detail',
    name: 'SupplierProjectDetail',
    component: () => import('../views/supplier/project/Detail.vue'),
    meta: { title: '项目详情' }
  },
  {
    path: '/admin-center',
    name: 'AdminCenter',
    component: () => import('../views/admin/Layout.vue'),
    meta: { title: '管理员中心' },
    redirect: '/admin-center/project-management',
    children: [
      {
        path: 'project-management',
        name: 'AdminProjectManagement',
        component: () => import('../views/admin/project/index.vue'),
        meta: { title: '项目管理' }
      },
      {
        path: 'expert-management',
        name: 'AdminExpertManagement',
        component: () => import('../views/admin/expert/index.vue'),
        meta: { title: '专家库' }
      },
      {
        path: 'account-management',
        name: 'AdminAccountManagement',
        component: () => import('../views/admin/account/index.vue'),
        meta: { title: '招标方账户' }
      },
       {
        path: 'supplier-management',
        name: 'AdminSupplierManagement',
        component: () => import('../views/admin/Supplier/index.vue'),
        meta: { title: '供应商' }
      },
      {
        path: 'business-cooperation',
        name: 'AdminBusinessCooperation',
        component: () => import('../views/admin/account/BusinessCooperation.vue'),
        meta: { title: '商务合作' }
      },
      {
        path: 'policy-management',
        name: 'AdminPolicyManagement',
        component: () => import('../views/admin/policy/index.vue'),
        meta: { title: '法律法规' }
      },
      {
        path: 'question-bank-management',
        name: 'QuestionBankManagement',
        component: () => import('../views/admin/knowledge/index.vue'),
        meta: { title: '题库管理' }
      },
      {
        path: 'personal-info',
        name: 'AdminPersonalInfo',
        component: () => import('../views/personalInfo/projectAdmin.vue'),
        meta: { title: '个人信息' }
      },
     
      {
        path: 'expert-category-management',
        name: 'AdminExpertCategoryManagement',
        component: () => import('../views/admin/expert/Category.vue'),
        meta: { title: '专业特长管理' }
      },
    ]
  },
   {
    path: '/supplier-center',
    name: 'SupplierCenter',
    component: () => import('../views/admin/Layout.vue'),
    meta: { title: '供应商中心' },
    redirect: '/supplier-center/project-management',
    children: [
      {
        path: 'project-management',
        name: 'SupplierProjectManagement',
        component: () => import('../views/supplier/project/index.vue'),
        meta: { title: '项目管理' }
      },
      {
        path: 'personal-info',
        name: 'SupplierPersonalInfo',
        component: () => import('../views/personalInfo/supplier.vue'),
        meta: { title: '个人信息' }
      }
    ]
  },
  {
    path: '/expert-center',
    name: 'ExpertCenter',
    component: () => import('../views/admin/Layout.vue'),
    meta: { title: '专家中心' },
    redirect: '/expert-center/project-management',
    children: [
       {
        path: 'project-management',
        name: 'ExpertProjectManagement',
        component: () => import('../views/expert/project/index.vue'),
        meta: { title: '项目管理' }
      },
      {
        path: 'personal-info',
        name: 'ExpertPersonalInfo',
        component: () => import('../views/personalInfo/expert.vue'),
        meta: { title: '个人信息' }
      }
    ]
  },
  {
    path: '/tenderer-center',
    name: 'TendererCenter',
    component: () => import('../views/admin/Layout.vue'),
    meta: { title: '投标人中心' },
    redirect: '/tenderer-center/project-management',
    children: [
       {
        path: 'project-management',
        name: 'TendererProjectManagement',
        component: () => import('../views/tenderer/project/index.vue'),
        meta: { title: '项目管理' }
      },
      {
        path: 'personal-info',
        name: 'TendererPersonalInfo',
        component: () => import('../views/personalInfo/tenderer.vue'),
        meta: { title: '个人信息' }
      }
    ]
  },
   {
        path: '/project-initiation',
        name: 'AdminProjectInitiation',
        component: () => import('../views/admin/project/Initiation.vue'),
        meta: { title: '立项' }
      },
      {
        path: '/project-detail',
        name: 'AdminProjectDetail',
        component: () => import('../views/admin/project/Detail.vue'),
        meta: { title: '项目详情' }
      }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;